export const FIRESTORE_DATABASE_ID = "geoanalytics-app";
export const STORAGE_BUCKET_NAME = "geoanalytics-6879a";
export const STORAGE_BUCKET_URL = `gs://${STORAGE_BUCKET_NAME}`;
export const FIREBASE_REGION = "southamerica-east1";
export const PUBLIC_APP_URL = "https://geoanalytics.app.br";
